import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconStar from '../../assets/icons/source/star.svg';

import { StarStyled, RatingStyled } from './Rating.styled';

const Star = ({
  readOnly,
  onMouseOver,
  onFocus,
  ...props
}) => (
  <StarStyled
    disabled={readOnly}
    onMouseOver={readOnly ? undefined : onMouseOver}
    onFocus={readOnly ? undefined : onFocus}
    type="button"
    {...props}
  >
    <IconStar />
  </StarStyled>
);

Star.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

const Rating = ({ initialAmount, onChange, readOnly }) => {
  const [amount, setAmout] = useState(initialAmount);
  const [previewAmout, setPreviewAmout] = useState(0);

  const handleClick = (rating) => {
    setAmout(rating);
    onChange(rating);
  };

  return (
    <RatingStyled>
      {Array.from({ length: 5 }).map((_, index) => (
        <Star
          readOnly={readOnly}
          key={+index}
          onMouseOver={() => setPreviewAmout(index + 1)}
          onFocus={() => setPreviewAmout(index + 1)}
          onMouseLeave={() => setPreviewAmout(0)}
          onBlur={() => setPreviewAmout(0)}
          onClick={() => handleClick(index + 1)}
          isActive={index < amount}
          isPreview={index < previewAmout}
        />
      ))}
    </RatingStyled>
  );
};

Rating.propTypes = {
  initialAmount: PropTypes.number,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

Rating.defaultProps = {
  initialAmount: 0,
  onChange: () => {},
  readOnly: false,
};

export default Rating;
